module.exports = __webpack_public_path__ + "static/img/10.09b7f470.png";